/*
 * Lets a link inside the product description jump straight to the product video.
 *
 * Usage: in a product's description (HTML mode), add:
 *   <a href="#video">▶ Se video av produktet</a>
 * On click this finds the video's thumbnail and *clicks it* — the exact same path
 * as a normal thumbnail click. The theme then:
 *   - switches the gallery to the video (with prepend=false, so the thumbnails are
 *     NOT reordered — unlike calling setActiveMedia directly, which hits the
 *     variant-image-filter hook and would move the video to thumbnail #1),
 *   - autoplays it (the theme's playActiveMedia loads the deferred video), and
 *   - scrolls the page up to the gallery (so mobile users don't have to hunt for
 *     the last thumbnail).
 *
 * Video media ids come from the #variant-image-data JSON (videoIds), rendered by
 * sections/main-product.liquid. The gallery uses section-prefixed media ids
 * ("<sectionId>-<mediaId>"), so we match the raw id by suffix.
 */
(function () {
  function firstVideoId() {
    // Multi-variant products expose video ids in #variant-image-data.
    var el = document.getElementById('variant-image-data');
    if (el) {
      try {
        var data = JSON.parse(el.textContent);
        if (data.videoIds && data.videoIds.length) return String(data.videoIds[0]);
      } catch (e) {}
    }

    // Fallback: products with no variants don't render that data block
    // (it's gated by `product.variants.size > 1`), so detect the video from
    // the gallery DOM instead. Video media render a <deferred-media> element
    // in the viewer; 3D models use <product-model>, so this won't match them.
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      var items = gallery.querySelectorAll('[id^="GalleryViewer"] .product__media-item');
      for (var i = 0; i < items.length; i++) {
        if (items[i].querySelector('deferred-media')) {
          var m = String(items[i].dataset.mediaId || '').match(/(\d+)$/);
          if (m) return m[1];
        }
      }
    }
    return '';
  }

  function showVideo() {
    var videoId = firstVideoId();
    if (!videoId) return false;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return false;

    // Preferred path: click the video's thumbnail button, exactly like a user
    // would. This uses the gallery's original (prepend=false) handler, so it
    // plays + scrolls without reordering the thumbnails.
    var thumbBtn =
      gallery.querySelector('[id^="GalleryThumbnails"] [data-target$="-' + videoId + '"] button') ||
      gallery.querySelector('[id^="GalleryThumbnails"] [data-target="' + videoId + '"] button');
    if (thumbBtn) {
      thumbBtn.click();
      return true;
    }

    // Fallback for products with no thumbnail strip: activate + play directly.
    var item =
      gallery.querySelector('[data-media-id$="-' + videoId + '"]') ||
      gallery.querySelector('[data-media-id="' + videoId + '"]');
    if (item && typeof gallery.setActiveMedia === 'function') {
      try {
        gallery.setActiveMedia(item.dataset.mediaId, false);
      } catch (e) {}
    }
    gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var poster = document.getElementById('Deferred-Poster-Modal-' + videoId);
    if (poster) {
      setTimeout(function () {
        poster.click();
      }, 350);
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#video"]');
    if (!link) return;
    if (!document.querySelector('media-gallery')) return; // not a product page with a gallery
    if (showVideo()) {
      e.preventDefault();
    }
  });
})();
